import React, { Dispatch, FC, SetStateAction } from 'react';
import { Button, Typography } from 'antd';

type Props = {
  onCancel?: (...args: any[]) => any;
  setStep: Dispatch<SetStateAction<number>>;
}


const StayStep:FC<Props> = ({ onCancel, setStep }) => {

  const handleStayClick = () => {
    onCancel?.()
  }

  const handleContinueToCancel = () => {
    setStep(2)
  }

  return (
    <div className="flex-col gap-16">
      <Typography.Title level={2} style={{ color: "#111" }}>
        We'd Love for You to Stay!
      </Typography.Title>
      <Typography>
        Before making your final decision, please consider how Mortgage Maker helps you:
      </Typography>
      <ul style={{ paddingLeft: "20px" }}>
        <li>
          <Typography.Text strong>Stay Connected with Clients:</Typography.Text> Your active subscription ensures that
          all report links shared with your clients stay accessible, maintaining your professional image.
        </li>
        <li>
          <Typography.Text strong>Preserve Your Valuable Data:</Typography.Text> By staying, you keep all your
          reports, usage history, referrals, and analytics safe and accessible.
        </li>
      </ul>
      <Typography>
        If affordability is your main concern, please reach out to our Support Team. We’re committed to working with
        you to find a solution that fits your needs.
      </Typography>
      <Typography>
        We’re here for you and your team and would love to keep supporting your business.
      </Typography>
      <Typography>
        <Typography.Text strong>Need assistance? </Typography.Text>
        Contact us at <a href="mailto:Support@MortgageMaker.ai">Support@MortgageMaker.ai</a> or <a
        href="tel:+16505025002">(650) 502-5002</a>. We're here to help!
      </Typography>
      <div className="flex-row flex-justify-end gap-12">
        <Button type="primary" size="large" onClick={handleStayClick}>
          I'd Like to Stay!
        </Button>
        <Button type="default" size="large" onClick={handleContinueToCancel}>
          Continue to Cancel
        </Button>
      </div>
    </div>
  )
}

export default StayStep;
